module.exports = __webpack_public_path__ + "assets/img/Currency1.683fdb4f.png";